import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

// Создаем контекст
const StatusRadio = process.env.GATSBY_RADIO_DATA || '';
const RadioContext = createContext();


// Провайдер радио
export const RadioProvider = ({ children }) => {
  const [trackTitle, setTrackTitle] = useState("");

  // 🔹 Используем useCallback, чтобы избежать пересоздания функции
  const fetchRadioStatus = useCallback(async () => {
    if (!StatusRadio) {
      console.error("GATSBY_RADIO_DATA не задан");
      return;
    }

    try {
      const response = await axios.get(StatusRadio);
      const { icestats } = response.data;

      if (icestats?.source) {
        setTrackTitle(icestats.source.title);
      }
    } catch (error) {
      console.error("Ошибка получения статуса радио:", error);
    }
  }, []);

  useEffect(() => {
    fetchRadioStatus(); // 🔹 Первый вызов сразу

    const intervalId = setInterval(fetchRadioStatus, 15000);

    return () => clearInterval(intervalId);
  }, [fetchRadioStatus]);

  return (
    <RadioContext.Provider value={{ trackTitle }}>
      {children}
    </RadioContext.Provider>
  );
};

// Хук для работы с радио
export const useRadio = () => {
  const context = useContext(RadioContext);
  if (!context) {
    console.warn("useRadio вызывается вне RadioProvider");
    return { trackTitle: "" }; // 🔹 Теперь просто возвращает пустую строку
  }
  return context;
};